'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SpicySvg;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SpicySvg(props) {
  var size = props.size,
      secondaryColor = props.secondaryColor,
      primaryColor = props.primaryColor,
      _props$i18n = props.i18n,
      i18n = _props$i18n === undefined ? { get: function get() {
      return null;
    } } : _props$i18n;


  return _react2.default.createElement(
    'svg',
    { role: 'img', 'aria-labelledby': 'bgimgSpicy', width: size, height: size, viewBox: '0 0 24 24', xmlns: 'http://www.w3.org/2000/svg',
      'data-hook': 'wixrest-menus-icon-full-bg-spicy' },
    _react2.default.createElement(
      'title',
      { id: 'bgimgSpicy' },
      ' ',
      i18n.get('openrest_menubuilderv3_dishlabels_spicy') || 'spicy'
    ),
    _react2.default.createElement(
      'g',
      { fill: 'none' },
      _react2.default.createElement('circle', { fill: primaryColor, cx: '12', cy: '12', r: '12' }),
      _react2.default.createElement('path', {
        d: 'M16.5052633 10.0980368c.2433592 1.2854072-.9542745 3.3655502-2.9797127 5.1757294-1.8807641 1.6832487-5.09904549 2.0422534-6.15296319 1.7779729.17533358-.0464149.40240494-.089988.58923581-.1269304 1.2052986-.2358632 3.22307198-.6289686 4.35268008-2.9894952.4579752-.955767.5202521-1.9011144.5700737-2.6598551.0105392-.168609.0210783-.3296401.0354499-.4821461.0651513-.6753834.2615632-1.55442382.8278045-1.90111433.4886346-.30027566 1.1717648-.14303351 1.656567.04167864h.0009581c.6371411.24059943.9973894.62139064 1.0999068 1.16416019m1.1094879-4.26542993c-.3947401-.13545559-.7913963-.10419661-1.1516446.09282969-.6524708.35711017-1.0376299 1.18310505-1.2407485 1.76755326-.9897246-.23302149-1.6690224-.01894484-2.0810084.23302149-.7751086.47551539-1.235 1.40381239-1.3653025 2.76026269-.0162878.1629256-.026827.3362708-.0392824.5162468-.045031.6962227-.0967688 1.4862224-.4608495 2.2468576-.8824165 1.8433326-2.35406887 2.1303469-3.53637291 2.3605266-.78756395.152506-1.76674931.3438488-1.7389642 1.3062465.00574864.2263908.10826609.6441245.71666403.9017743.36599688.1544004.8891233.2320742 1.50231178.2320742 1.835733 0 4.4734016-.6990645 6.0763146-2.1322414 2.3837702-2.1303468 3.6638012-4.5173962 3.3390029-6.22906222-.107308-.56171441-.4321063-1.29014337-1.3375174-1.79218154.1686268-.4868823.4368968-1.02017945.7233708-1.17647436.071858-.03978415.1322188-.04357312.214616-.01515586.2998875.1041966.62756-.05304555.7319937-.348585.1053918-.29648669-.0526959-.6204434-.3525834-.72369275',
        fill: secondaryColor })
    )
  );
}

SpicySvg.displayName = 'SpicySvg';
SpicySvg.propTypes = {
  size: _propTypes2.default.number,
  secondaryColor: _propTypes2.default.string,
  primaryColor: _propTypes2.default.string
};
SpicySvg.defaultProps = {
  size: 28,
  secondaryColor: '#fff',
  primaryColor: '#c4270e'
};